module.exports = __webpack_public_path__ + "media/images/pc/static/icon-compare-547d28c2686e716254db28e3eb3c03cd.png";